import { cva } from 'class-variance-authority';
import classnames from 'classnames';
import { CSSProperties, PropsWithChildren } from 'react';

const TextVariants = cva('', {
  variants: {
    color: {
      primary: 'text-text-primary',
      secondary: 'text-text-secondary',
      tertiary: 'text-text-tertiary',
      description: 'text-text-description',
      white: 'text-white',
      black: 'text-black'
    },
    weight: {
      semibold: 'font-semibold',
      medium: 'font-medium',
      regular: 'font-regular'
    },
    size: {
      heading1: 'text-heading1',
      heading2: 'text-heading2',
      heading3: 'text-heading3',
      body1: 'text-body1',
      body2: 'text-body2',
      small: 'text-small',
      medium: 'text-medium',
      header: 'text-header'
    }
  }
});

interface Props extends PropsWithChildren {
  className?: string;
  color?: 'primary' | 'secondary' | 'tertiary' | 'description' | 'white' | 'black';
  weight?: 'semibold' | 'medium' | 'regular';
  size?: 'heading1' | 'heading2' | 'heading3' | 'body1' | 'body2' | 'small' | 'medium' | 'header';
  style?: CSSProperties;
  text?: string | number;
}

const Text = ({ children, className, color = 'primary', weight = 'medium', size = 'body2', style }: Props) => {
  return (
    <p className={classnames(TextVariants({ color, weight, size }), className)} style={style}>
      {children}
    </p>
  );
};

export default Text;
